import { l10n } from '@ott/l10n';

const CODES = {
  GETTING_CARD_ERROR: 'GETTING_CARD_ERROR',
  REPLENISH_REQUEST_ERROR: 'REPLENISH_REQUEST_ERROR',
};

export const getErrorByCode = (err: string) => {
  let error = '';

  switch (err) {
    case CODES.GETTING_CARD_ERROR: {
      error = l10n('virtualCard.refillForm.errors.gettingCardError');
      break;
    }
    case CODES.REPLENISH_REQUEST_ERROR:
    default: {
      error = l10n('virtualCard.refillForm.errors.replenishError');
      break;
    }
  }

  return error;
};
